import React, { useEffect, useReducer, useRef } from 'react';
import { useDocumentViewerFiles } from './useDocumentViewerFiles';
import DocumentsViewerButton from './DocumentsViewerButton';
import { ClaimContext } from '../types';
import { useFlag } from '@unleash/proxy-client-react';

interface UseDocumentsViewerProps {
  claim: ClaimContext;
  workflowStep: string;
}

export function useDocumentsViewer(props: UseDocumentsViewerProps) {
  const { claim, workflowStep } = props;

  const [isDocumentsViewerOpen, toggleDocumentsViewer] = useReducer((state: boolean) => !state, false);

  const documentViewerFiles = useDocumentViewerFiles(claim);

  const documentsViewerButtonElement = (
    <DocumentsViewerButton isViewerOpen={isDocumentsViewerOpen} onClick={toggleDocumentsViewer} />
  );

  const previousDocumentCount = useRef(documentViewerFiles.length);

  useEffect(() => {
    const isNotDelete = documentViewerFiles.length > previousDocumentCount.current;

    const shouldOpenDocumentsViewer = !isDocumentsViewerOpen && documentViewerFiles.length > 0 && isNotDelete;

    if (shouldOpenDocumentsViewer) {
      toggleDocumentsViewer();
    }

    previousDocumentCount.current = documentViewerFiles.length;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowStep, documentViewerFiles]);

  return {
    documentsViewerButtonElement,
    documentViewerFiles,

    isDocumentsViewerOpen,
    toggleDocumentsViewer,
  };
}
